import { render, staticRenderFns } from "./chooseDiningMethod.vue?vue&type=template&id=57954fd8&scoped=true"
import script from "./chooseDiningMethod.vue?vue&type=script&lang=js"
export * from "./chooseDiningMethod.vue?vue&type=script&lang=js"
import style0 from "./chooseDiningMethod.vue?vue&type=style&index=0&id=57954fd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57954fd8",
  null
  
)

export default component.exports